(function(){
  var E = window.LRC_EXP;
  if(!E || !E.assigned) return;
  var keys = Object.keys(E.assigned);

  /* Remove losing experiment arms from the DOM before the page JS binds.
     CSS hiding is not sufficient: querySelector still finds hidden nodes, so a
     hidden arm's pickers, sticky bars and templates collide with the visible one.
     Runs at defer-execution time, which is after HTML parse and before the
     page's own deferred scripts execute. */
  (function pruneArms(){
    try{
      var nodes = document.querySelectorAll('[data-exp-arm]');
      var seen = {};
      for(var i = nodes.length - 1; i >= 0; i--){
        var n = nodes[i];
        var parts = (n.getAttribute('data-exp-arm') || '').split(':');
        if(parts.length !== 2) continue;
        var k = parts[0], arm = parts[1], want = E.assigned[k], keep;
        if(want){ keep = (arm === want); }
        else { keep = !seen[k]; seen[k] = 1; }
        if(!keep && n.parentNode) n.parentNode.removeChild(n);
      }
    }catch(err){}
  })();

  var PROXY = '/apps/lrc';
  var SEEN_COOKIE = 'lrc_exp_seen';
  var origFetch = window.fetch;

  function ssGet(k){ try{ return sessionStorage.getItem(k); }catch(e){ return null; } }
  function ssSet(k,v){ try{ sessionStorage.setItem(k,v); }catch(e){} }

  function cookieGet(name){
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function cookieSet(name, val){
    try{ document.cookie = name + '=' + encodeURIComponent(val) + ';path=/;max-age=15552000;SameSite=Lax;Secure'; }catch(e){}
  }

  function seenMap(){
    var out = {}, raw = cookieGet(SEEN_COOKIE);
    if(!raw) return out;
    var parts = raw.split(';');
    for(var i=0;i<parts.length;i++){
      var kv = parts[i].split('=');
      if(kv.length === 2 && kv[0] && kv[1]) out[kv[0]] = kv[1];
    }
    return out;
  }
  function markSeen(key, arm){
    var m = seenMap();
    if(m[key] === arm) return;
    m[key] = arm;
    var out = [];
    for(var k in m){ if(Object.prototype.hasOwnProperty.call(m,k)) out.push(k + '=' + m[k]); }
    cookieSet(SEEN_COOKIE, out.join(';'));
  }
  function expString(){
    var m = seenMap(), out = [];
    for(var i=0;i<keys.length;i++){
      var k = keys[i];
      if(Object.prototype.hasOwnProperty.call(m,k)) out.push(k + '=' + m[k]);
    }
    return out.join(';');
  }

  function tagClarity(){
    try{ if(window.clarity) window.clarity('set','lrc_exp', expString()); }catch(e){}
  }

  function beacon(key, arm){
    markSeen(key, arm);
    tagClarity();
    var mark = 'lrc_exp_beacon_' + key;
    if(ssGet(mark)) return;
    ssSet(mark, arm);
    var payload = JSON.stringify({ action:'exp_expose', key:key, arm:arm, vid:E.vid });
    var sent = false;
    try{
      var blob = new Blob([payload], { type:'application/json' });
      sent = navigator.sendBeacon(PROXY, blob);
    }catch(e){}
    if(!sent){
      try{
        origFetch(PROXY, { method:'POST', headers:{'Content-Type':'application/json'}, body:payload, keepalive:true }).catch(function(){});
      }catch(e){}
    }
  }

  var io = null;
  if(window.IntersectionObserver){
    io = new IntersectionObserver(function(ents){
      for(var i=0;i<ents.length;i++){
        var en = ents[i];
        if(en.intersectionRatio <= 0) continue;
        var parts = (en.target.getAttribute('data-exp-arm') || '').split(':');
        if(parts.length !== 2) continue;
        if(E.assigned[parts[0]] !== parts[1]) continue;
        io.unobserve(en.target);
        beacon(parts[0], parts[1]);
      }
    }, { threshold: 0 });
  }

  function scan(){
    if(!keys.length) return;
    var nodes = document.querySelectorAll('[data-exp-arm]');
    for(var i=0;i<nodes.length;i++){
      var parts = (nodes[i].getAttribute('data-exp-arm') || '').split(':');
      if(parts.length !== 2) continue;
      if(E.assigned[parts[0]] !== parts[1]) continue;
      if(io) io.observe(nodes[i]);
      else beacon(parts[0], parts[1]);
    }
  }

  var writeTimer = null;
  function doWrite(){
    var s = expString();
    if(!s) return;
    if(ssGet('lrc_exp_cartattr') === s) return;
    ssSet('lrc_exp_cartattr', s);
    try{
      origFetch('/cart/update.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ attributes: { _lrc_exp: s } })
      }).catch(function(){ ssSet('lrc_exp_cartattr',''); });
    }catch(e){}
  }
  function scheduleWrite(){
    if(writeTimer) clearTimeout(writeTimer);
    writeTimer = setTimeout(doWrite, 800);
  }

  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var p = origFetch.apply(this, arguments);
    if(url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1){
      try{ p.then(function(r){ if(r && r.ok) scheduleWrite(); }).catch(function(){}); }catch(e){}
    }
    return p;
  };

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scan);
  } else { scan(); }
  window.addEventListener('load', function(){
    setTimeout(scan, 0);
    if(location.pathname.indexOf('/cart') === 0) scheduleWrite();
  });

  function sendRaw(payload){
    var s = JSON.stringify(payload), sent = false;
    try{ sent = navigator.sendBeacon(PROXY, new Blob([s], { type:'application/json' })); }catch(e){}
    if(!sent){
      try{ origFetch(PROXY, { method:'POST', headers:{'Content-Type':'application/json'}, body:s, keepalive:true }).catch(function(){}); }catch(e){}
    }
  }

  // Manual exposure, for arms chosen by JS rather than shown/hidden by CSS
  // (pre-purchase upsells). Session-deduped inside beacon().
  window.LRC_EXP.expose = function(key, arm){
    try{ if(key && arm) beacon(key, arm); }catch(e){}
  };

  // Generic per-arm event counter. Session-deduped per key+event.
  window.LRC_EXP.event = function(key, arm, name){
    try{
      if(!key || !arm || !name) return;
      var mark = 'lrc_exp_ev_' + key + '_' + name;
      if(ssGet(mark)) return;
      ssSet(mark, arm);
      sendRaw({ action:'exp_event', key:key, arm:arm, event:name, vid:E.vid });
    }catch(e){}
  };

  window.LRC_EXP.expString = expString;
  window.LRC_EXP.seenMap = seenMap;
  window.LRC_EXP.debug = function(){
    return { vid: E.vid, assigned: E.assigned, seen: seenMap(), emitted: expString() };
  };
})();
